export function formatTextInput(value) {
  return value.replace(
    /[^a-zA-Z0-9.,!?'''&_*/#()áàâäãåçéèêëíìîïñóòôöõøúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕØÚÙÛÜÝ + @ \- \n]/g,
    ''
  );
}

export function trim_dataset(
  dataset,
  preserveWhitespaceFields = ['comments', 'internal_comments']
) {
  return Object.keys(dataset).reduce((acc, key) => {
    const value = dataset[key];
    if (typeof value === 'string') {
      acc[key] = preserveWhitespaceFields.includes(key) ? value : value.trim();
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function formatWeight(value) {
  if (!value) return value;
  if (typeof value === 'string' && value.includes('T')) return value;
  const numericValue = parseInt(value, 10);
  if (isNaN(numericValue)) return value;
  const tonnes = Math.floor(numericValue / 1000);
  const kg = numericValue % 1000;
  return `${tonnes}T${kg.toString().padStart(3, '0')}`;
}

export function formatHour(value) {
  if (!value) return value;
  const trimmed = value.trim();
  if (/^\d{1,2}$/.test(trimmed)) {
    return `${trimmed}h`;
  }
  return value;
}
